import { useState, useEffect } from 'react';
import './ScienceExhibition.css';
import sciencePic1 from '../scienceexihibition/science (1).webp'
import sciencePic2 from '../scienceexihibition/science (2).webp'
import sciencePic3 from '../scienceexihibition/science (3).webp'
import sciencePic4 from '../scienceexihibition/science (4).webp'
import sciencePic5 from '../scienceexihibition/science (6).webp'
import sciencePic6 from '../scienceexihibition/science (7).webp'
import sciencePic7 from '../scienceexihibition/science (8).webp'
import sciencePic8 from '../scienceexihibition/science (9).webp'
import sciencePic12 from '../scienceexihibition/science (13).webp'
import sciencePic13 from '../scienceexihibition/science (14).webp'
import sciencePic14 from '../scienceexihibition/science (15).webp'
import sciencePic15 from '../scienceexihibition/science (16).webp'
import sciencePic16 from '../scienceexihibition/science (17).webp'
import sciencePic17 from '../scienceexihibition/science (18).webp'
import sciencePic18 from '../scienceexihibition/science (19).webp'
import sciencePic19 from '../scienceexihibition/science (20).webp'
import sciencePic20 from '../scienceexihibition/science (21).webp'

const ScienceExhibitionPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Gallery images for Session 2024-25
  const galleryImages = [
    { id: 2, src: sciencePic2, alt: 'Science Exhibition 2' },
    { id: 4, src: sciencePic4, alt: 'Science Exhibition 4' }, 
    { id: 3, src: sciencePic3, alt: 'Science Exhibition 3' },  
    { id: 6, src: sciencePic6, alt: 'Science Exhibition 6' },
    { id: 8, src: sciencePic8, alt: 'Science Exhibition 8' },
    { id: 14, src: sciencePic14, alt: 'Science Exhibition 14' },
    { id: 21, src: sciencePic20, alt: 'Science Exhibition 21' },
    { id: 18, src: sciencePic18, alt: 'Science Exhibition 18' },
    { id: 19, src: sciencePic19, alt: 'Science Exhibition 19' },
    { id: 20, src: sciencePic20, alt: 'Science Exhibition 20' },
    { id: 7, src: sciencePic7, alt: 'Science Exhibition 7' },
    { id: 17, src: sciencePic17, alt: 'Science Exhibition 17' },
    { id: 12, src: sciencePic12, alt: 'Science Exhibition 12' },
    { id: 13, src: sciencePic13, alt: 'Science Exhibition 13' },
    { id: 15, src: sciencePic15, alt: 'Science Exhibition 15' },
    { id: 16, src: sciencePic16, alt: 'Science Exhibition 16' },
    { id: 1, src: sciencePic1, alt: 'Science Exhibition 1' },
    { id: 5, src: sciencePic5, alt: 'Science Exhibition 5' },
  ];

  useEffect(() => {
    setAllImages(galleryImages);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = galleryImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex]);

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>SCIENCE EXHIBITION</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Science Exhibition</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="science-container">
        {/* Title Section */}
        <div className="science-title-section">
          <h2>SCIENCE EXHIBITION</h2>
          <div className="science-title-underline"></div>
        </div>

        {/* Session Gallery */}
        <section className="science-gallery-section">
          
          <div className="science-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`science-gallery-item ${index % 2 === 0 ? 'science-left' : 'science-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && (
        <div className="science-modal show" onClick={(e) => {
          if (e.target.classList.contains('science-modal')) {
            closeModal();
          }
        }}>
          <div className="science-modal-wrapper">
            <button className="science-modal-close" onClick={closeModal}>&times;</button>
            <button className="science-modal-btn science-modal-prev" onClick={prevImage}>❮</button>
            <img 
              className="science-modal-image" 
              src={galleryImages[currentImageIndex].src} 
              alt={galleryImages[currentImageIndex].alt}
            />
            <button className="science-modal-btn science-modal-next" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ScienceExhibitionPage;